import useSWR from "swr";
import fetcher from "../../../lib/fetcher";
import { FacilitySchemaResponseWrapper } from "./types";

const useFacilityItemById = (facilityId: number) => {
  const { data, error, isLoading, mutate } = useSWR(
    `/facility/${facilityId}`,
    (url) => fetcher.swr<FacilitySchemaResponseWrapper>(url),
    { errorRetryCount: 0, revalidateOnFocus: false }
  );

  return {
    data: data?.data,
    error,
    isLoading,
    mutate,
  };
};

export default useFacilityItemById;
